"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import IconCustom from "@/components/iconCustom";
import { useModalStore } from "@/stores/modal-store";
import { Club } from "@/TS/Interfaces/global_interfaces";
import EditIcon from "./edit-icon";
import { ModalSocialNetwork } from "./modal-social-network";
interface SocialNetworkProps {
  club: Club;
  public?: boolean;
}
export const SocialNetwork = props => {
  const $ = _c(33);
  const isPresident = props.club.userRole === "ROLE_PRESIDENT";
  let t0;
  if ($[0] !== props.club.slug) {
    t0 = ["club", props.club.slug, "socialNetwork"];
    $[0] = props.club.slug;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.club.socialNetworks) {
    t1 = () => props.club.socialNetworks || {};
    $[2] = props.club.socialNetworks;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    data: socialNetworkQueries
  } = useQuery(t2);
  const t3 = socialNetworkQueries?.linkedin;
  let t4;
  if ($[7] !== t3) {
    t4 = {
      icon: "/icons/linkedin-icon.svg",
      url: t3,
      alt: "Linkedin",
      title: "LinkedIn"
    };
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = socialNetworkQueries?.facebook;
  let t6;
  if ($[9] !== t5) {
    t6 = {
      icon: "/icons/facebook-icon.svg",
      url: t5,
      alt: "Facebook",
      title: "Facebook"
    };
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = socialNetworkQueries?.x;
  let t8;
  if ($[11] !== t7) {
    t8 = {
      icon: "/icons/x-icon.svg",
      url: t7,
      alt: "X",
      title: "X"
    };
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t4 || $[14] !== t6 || $[15] !== t8) {
    t9 = [t4, t6, t8];
    $[13] = t4;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const socialMedia = t9;
  const t10 = socialNetworkQueries?.messaging;
  let t11;
  if ($[17] !== t10) {
    t11 = {
      icon: "/icons/messaging-icon.svg",
      url: t10,
      alt: "Messagerie",
      title: "Messagerie"
    };
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const messagingMedia = t11;
  let t12;
  if ($[19] !== props.public || $[20] !== socialMedia) {
    t12 = !props.public ? socialMedia.map(_temp) : socialMedia.map(_temp2);
    $[19] = props.public;
    $[20] = socialMedia;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== isPresident || $[23] !== messagingMedia || $[24] !== props.public) {
    t13 = !props.public && isPresident && messagingMedia.url && <IconCustom src={messagingMedia.icon} width={30} height={30} alt={messagingMedia.alt} title={messagingMedia.title} className="mr-3" disabled={false} onClick={() => window.open(messagingMedia.url, "_blank")} />;
    $[22] = isPresident;
    $[23] = messagingMedia;
    $[24] = props.public;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== isPresident || $[27] !== props.club.slug) {
    t14 = isPresident && <div onClick={() => {
      useModalStore.getState().open({
        component: <ModalSocialNetwork clubSlug={props.club.slug} />,
        modalOptions: {
          closeOnOverlayClick: false
        }
      });
    }}><EditIcon className="relative right-0 left-1 top-0" /></div>;
    $[26] = isPresident;
    $[27] = props.club.slug;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t12 || $[30] !== t13 || $[31] !== t14) {
    t15 = <><div className="md:text-lg mb-4 md:mb-8 mt-0 flex gap-1">{t12}{t13}{t14}</div></>;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  return t15;
};
function _temp(item, index) {
  return <IconCustom key={`${item.url}-${index}`} src={item.icon} width={30} height={30} alt={item.alt} title={item.title} className="mr-3" disabled={item.url === "" || item.url === undefined} onClick={() => {
    if (item.url !== "" && item.url !== undefined) {
      window.open(item.url, "_blank");
    }
  }} />;
}
function _temp2(item_0, index_0) {
  return item_0.url && <IconCustom key={`${item_0.url}-${index_0}`} src={item_0.icon} width={30} height={30} alt={item_0.alt} title={item_0.title} className="mr-3" disabled={item_0.url === "" || item_0.url === undefined} onClick={() => {
    if (item_0.url !== "" && item_0.url !== undefined) {
      window.open(item_0.url, "_blank");
    }
  }} />;
}